// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>3</span>&nbsp;&nbsp;The ploughers ploughed upon my back&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and made their furrows long.<br> </p> </div></div>";
// Exports
module.exports = code;